<div class="modal-header">
  <h5 class="modal-title">Attention, vous avez des changements non sauvegardés</h5>
</div>
<div class="modal-body">
  <p>Voulez-vous vraiment quitter? Vous allez perdre tous les changements non sauvegardés.</p>
</div>
<div class="modal-footer">
  <button (click)="activeModal.close(false)" class="btn btn-seconday" data-bs-dismiss="modal" type="button">Non</button>
  <button (click)="activeModal.close(true)" class="btn btn-danger" type="button">Oui je veux quitter cette page</button>
</div>
